import { render, staticRenderFns } from "./ProductLicenseProfileIndex.vue?vue&type=template&id=47b94ab7&scoped=true&"
import script from "./ProductLicenseProfileIndex.vue?vue&type=script&lang=js&"
export * from "./ProductLicenseProfileIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProductLicenseProfileIndex.vue?vue&type=style&index=0&id=47b94ab7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b94ab7",
  null
  
)

export default component.exports